// The ONE class string for a public-surface text input (act:22274f4d follow-up).
//
// WHY THIS EXISTS. It was a local const in Funnel/Signing.jsx, and the
// case-file pages — written later — hand-rolled their own
// `"mt-1 w-full rounded-md border-gray-300"` instead. That string names a
// border COLOR with no border WIDTH, and Tailwind's preflight resets inputs to
// `border-width: 0`. With no forms plugin installed (there isn't one), the
// result is a field with an invisible border and no padding: present, focusable,
// typeable, and visually absent. It shipped that way on 2026-08-10 and was
// caught by the operator looking at staging on 2026-08-13, not by any spec —
// nothing asserts that an input LOOKS like an input.
//
// So the fix is not "add the missing utilities to five call sites", which just
// sets up the sixth to diverge. One string, imported.
//
// `focus:` rather than `focus-visible:` is deliberate and carried over from the
// original: a text field focused by ANY means, including a click, should show
// it. That differs from the funnel's BUTTON convention
// (`focus-visible:ring-brand`, act:bf2ebd5f CP2) on purpose — a button that
// ringed on every mouse click would be noise.
export const formInputClass =
  "w-full px-3 py-2 border border-gray-300 rounded-md text-base focus:outline-none focus:ring-2 focus:ring-brand focus:border-transparent"
